import React from 'react';
import { Grid } from 'semantic-ui-react';

import { ChildrenPropType } from '../../services/proptypes';
import Image from './components/Image';
import Color from './components/Color';
import './Background.css';


const propTypes = {
  children: ChildrenPropType.isRequired,
};

function Background({children, ...gridProps}) {
  return (
    <Grid {...gridProps}>
      {children}
    </Grid>
  );
}

Background.propTypes = propTypes;

Background.Image = Image;
Background.Color = Color;

export default Background;
